import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import { CircularProgress } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import "../styling/sidebar.css";
import "../styling/expensepop.css";
import GetUser from "../services/get-user";
import RCPopup from "./fileDataHandlers/readCsv";
import Popup from "reactjs-popup";
import REPopup from "./fileDataHandlers/readExcel";
import Tooltip from "@mui/material/Tooltip";
import { InputGroup } from "react-bootstrap";

export default function EPopup(props) {
  const [name, setName] = useState("");
  const [usedate, setUseDate] = useState(new Date());
  const [amount, setAmount] = useState<any>("");
  const [site, setSite] = useState("");
  const [cat, setCat] = useState("");
  const [purchase, setPurchase] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const user = GetUser();

  function validateForm() {
    return name.length > 0 && Number(amount) > 0;
    //&& site.length > 0
  }

  const handleChange = (event) => {
    const { value } = event.target;
    const [, decimal] = value.split(".");
    if (decimal?.length < 3 || !value.includes(".")) {
      setAmount(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      //return axios.post('http://localhost:8080/expense/add_expense', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/expense/add_expense", {
          userID: user.userID,
          name,
          date: usedate,
          amount,
          site,
          category: cat,
          note,
          incomeStream: props.stream + 1,
        })
        .then((response) => {
          sessionStorage.setItem("option", "expense");
          setLoading(false)
          props.closeExpenseModal(false)
          props.setReloadAPI((prevState)=>!prevState)
        });
    } catch (e) {
      setLoading(false)
    }
  };

  const disableScroll = (e) => {
    const isFocused = document.activeElement === e.target
    if (isFocused) {
      e.target.blur()
      setTimeout(() => {
        e.target.focus()
      })
    }
  }

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <Popup
          trigger={
            <button className="expensecsvbutton"> Import CSV File </button>
          }
          modal
          nested
          className="csv"
        >
          {(close) => (
            <div className="mode">
              <button className="close" onClick={close}>
                &times;
              </button>
              <div className="header"> Import CSV </div>
              <div className="content">
                {" "}
                <RCPopup
                  stream={props.stream}
                  categories={props.categories}
                  setOpenCsvModal ={close}
                  setReloadAPI={props.setReloadAPI}
                  closeExpenseModal={props.closeExpenseModal}
                ></RCPopup>
                <br />
              </div>
            </div>
          )}
        </Popup>
        <Popup
          trigger={
            <button className="expensecsvbutton"> Import Excel File </button>
          }
          modal
          nested
          className="csv"
        >
          {(close) => (
            <div className="mode">
              <button className="close" onClick={close}>
                &times;
              </button>
              <div className="header"> Import Excel </div>
              <div className="content">
                <REPopup
                  stream={props.stream}
                  categories={props.categories}
                  setOpenExcelModal={close} 
                  setReloadAPI={props.setReloadAPI}
                  closeExpenseModal={props.closeExpenseModal}
                ></REPopup>
                <br />
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="or-container">
        <div className="line-1"> </div>
        <span className="or-text"> Or enter manually </span>
        <div className="line-2"> </div>
      </div>

      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="name" className="form-group required">
          <Form.Label className="control-label"> Expense Name </Form.Label>
          <Form.Control
            autoFocus
            type="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="amount" className="form-group required">
          <Form.Label className="control-label"> Amount $ </Form.Label>
          <div className="d-flex">
          <span className="font-currency mr-2 mt-1">$</span>
          <Form.Control
            autoFocus
            onWheel={disableScroll}
            type="number"
            step={0.01}
            placeholder="0.00"
            value={amount}
            onChange={(e) => handleChange(e)}
          />
          </div>
          </Form.Group>
        
        <Form.Group controlId="date">
          <Form.Label> Date Purchased </Form.Label>
          <DatePicker
            selected={usedate}
            maxDate={new Date()}
            onChange={(date) => setUseDate(date)}
            showTimeSelect
            dateFormate="Pp"
            className="date-picker-input"
          />
        </Form.Group>

        <Form.Group controlId="site">
          <Form.Label className="control-label"> Purchased From </Form.Label>
          <input
            className="form-control"
            type="text"
            list="purchasedform"
            onChange={(e) => setSite(e.target.value)}
          />
          <datalist id="purchasedform">
            {props.purchasedData.map((item, key) => (
              <option key={key} value={item} />
            ))}
          </datalist>
        </Form.Group>

        <Tooltip
          title="Create a new category by typing it and it will automatically save"
          placement="bottom"
        >
          <Form.Group controlId="cat">
            <Form.Label> Category </Form.Label>
            <input
              className="form-control"
              type="text"
              list="categories"
              onChange={(e) => setCat(e.target.value)}
            />
            <datalist id="categories">
              {props.categories.map((item, key) => (
                <option key={key} value={item} />
              ))}
            </datalist>
          </Form.Group>
        </Tooltip>

        <Form.Group controlId="note">
          <Form.Label> Note </Form.Label>
          <Form.Control
            autoFocus
            type="note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </Form.Group>

        <Button
          block
          size="sm"
          type="submit"
          disabled={!validateForm()}
          className="modal-add-button"
        >
          {loading ?
            <><CircularProgress className="file-loader mr-3" />Add Item</>
            : 'Add Item'
          }
        </Button>
      </Form>
    </div>
  );
}
